import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';

const DepartureTimePopup = ({ 
  dTime, 
  setDTime, 
  setShowDepartPopup 
}) => {
  return (
    <div style={{
      position: 'fixed',
      top: '35%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: '#2A3075',
      color: '#fff',
      padding: '1.5rem',
      borderRadius: '8px',
      width: '320px',
      zIndex: 10001,
      boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <span style={{ fontWeight: 'bold', fontSize: '1rem' }}>
          <FontAwesomeIcon icon={faMapMarkedAlt} style={{ marginRight: '0.5rem' }} />
          Departure Time
        </span>
        <button
          onClick={() => setShowDepartPopup(false)}
          style={{
            background: 'none',
            color: '#fff',
            border: 'none',
            fontSize: '18px',
            cursor: 'pointer'
          }}
        >
          ✕
        </button>
      </div>

      {/* Radio: Depart Now */}
      <div style={{ marginBottom: '1rem' }}>
        <label>
          <input
            type="radio"
            name="timeOption"
            checked={dTime === ""}
            onChange={() => {
              setDTime("");
              setShowDepartPopup(false);
            }}
            style={{ marginRight: '0.5rem' }}
          />
          Depart Now
        </label>
      </div>

      {/* Radio: Set Time */}
      <div style={{ marginBottom: '1rem' }}>
        <label>
          <input
            type="radio"
            name="timeOption"
            checked={dTime !== ""}
            onChange={() => {
              const now = new Date();
              const iso = now.toISOString().slice(0, 16);
              setDTime(iso);
            }}
            style={{ marginRight: '0.5rem' }}
          />
          Set Time & Date
        </label>
      </div>

      {/* Only show picker if "Set Time & Date" is active */}
      {dTime !== "" && (
        <input
          type="datetime-local"
          value={dTime}
          onChange={(e) => {
            setDTime(e.target.value);
            setShowDepartPopup(false);
          }}
          onKeyDown={(e) => e.preventDefault()}
          style={{
            width: '100%',
            padding: '0.4rem',
            borderRadius: '4px',
            border: 'none',
            fontSize: '0.9rem',
            color: '#000'
          }}
        />
      )}
    </div>
  );
};

export default DepartureTimePopup; 